import type { ExitStrategy } from '@/api/enums';
import { yupMixed, yupObject, yupString } from '../../yup';
import { ExitStrategyOptions } from '@/helpers/const';

export const exitStrategySchema = yupObject({
  exitStrategy: yupMixed<ExitStrategy>()
    .required()
    .oneOf(Object.keys(ExitStrategyOptions) as ExitStrategy[])
    .label('Loan repayment strategy'),
  exitStrategyDetails: yupString()
    .when('exitStrategy', ([exitStrategy], schema) => (exitStrategy === 'other' ? schema.required() : schema))
    .label('Loan repayment strategy details'),
});
